import { useRef } from "react";

// 3D tilt + spotlight card following the mouse. Light glass surface.
export default function TiltCard({ children, className = "", intensity = 8, ...props }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    el.style.transform = `perspective(900px) rotateY(${(px - 0.5) * intensity}deg) rotateX(${(0.5 - py) * intensity}deg) translateZ(0)`;
    el.style.setProperty("--mx", `${px * 100}%`);
    el.style.setProperty("--my", `${py * 100}%`);
  };
  const reset = () => {
    if (ref.current) ref.current.style.transform = "perspective(900px) rotateY(0) rotateX(0)";
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      className={`relative overflow-hidden rounded-3xl glass transition-transform duration-200 will-change-transform hover:shadow-[0_20px_50px_-16px_rgba(15,23,42,0.18)] ${className}`}
      style={{ transformStyle: "preserve-3d" }}
      {...props}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-3xl opacity-0 transition-opacity duration-300 hover:opacity-100"
        style={{ background: "radial-gradient(360px circle at var(--mx,50%) var(--my,50%), color-mix(in srgb, var(--brand) 12%, transparent), transparent 65%)" }}
      />
      {children}
    </div>
  );
}
